import { Component, Input } from '@angular/core';
import { LangService } from '../../services/lang.service';

@Component({
    selector: 'app-see-more-card',
    templateUrl: './see-more-card.component.html',
    styleUrls: ['./see-more-card.component.scss'],
    standalone: false
})
export class SeeMoreCardComponent {
    @Input() route: string = '/';
    @Input() label?: string;

    constructor(public lang: LangService) {}

    get displayLabel(): string {
        return this.label || this.lang.data?.['general.see_more'] || 'See more';
    }
}
